export default "# Does not automatically land you a job\n\n(0 = 3‿5⊸|)◶[⊢‿\"Buzz\", \"Fizz\"‿\"FizzBuzz\"]¨ 1 + ↕100\n";